import React, { useContext, Fragment } from 'react';
import Skeleton from '../../../../../../components/OtherElements/CustomSkeleton';
import BriefInfo from '../../../../../../components/User/BriefInfo';
import { store } from './Freight';
import { useFreight } from 'useStores/useFreight';

function CustomerInfo() {
  const { state } = useContext(store);
  const { freight } = state;

  return (
    <Fragment>
      {freight?._id ? (
        <BriefInfo user={freight} />
      ) : (
        <Skeleton count={3} height={38} />
      )}
    </Fragment>
  );
}

export default CustomerInfo;
